import { type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import { REPO_PICK_MAX_IDS } from '../lib/repo-enablement';
import type { RepoEnablementPicker } from '../lib/repo-enablement-picker';
import { count } from '../lib/time';
import { Button } from './ui/Button';

// What is selected, and the two ways to select more. Presenter.

export function RepoEnablementSelection(props: {
  readonly picker: RepoEnablementPicker;
}): JSX.Element {
  const matching = (): number => props.picker.matching() ?? 0;
  return (
    <>
      <div class="repo-enablement__selection">
        <Button variant="outline" size="sm" onClick={props.picker.pickPage}>
          {t('repo_enablement.select_page')}
        </Button>
        <Show when={matching() > 0}>
          <Button variant="outline" size="sm" onClick={props.picker.selectAllMatching}>
            {t('repo_enablement.select_all_matching', { n: count(matching()) })}
          </Button>
        </Show>
        <Show when={props.picker.selectedCount() > 0}>
          <span class="repo-enablement__line">
            {t('repo_enablement.selected', { n: count(props.picker.selectedCount()) })}
          </span>
          <Button variant="ghost" size="sm" onClick={props.picker.clearSelection}>
            {t('repo_enablement.clear')}
          </Button>
        </Show>
      </div>
      <Show when={props.picker.tooMany()}>
        <p class="repo-enablement__line" role="status">
          {t('repo_enablement.too_many', { n: count(REPO_PICK_MAX_IDS) })}
        </p>
      </Show>
    </>
  );
}
